class SideLabelDetail {
    constructor ($sideLabel, settings) {
        this.$sideLabel = $sideLabel;
        // this DOM Elements indicates when to show label
        this.$productName = document.querySelector('[data-side-label="product-name"]');
    }

    initialize () {
        if (this.$productName) {
            this.checkProductNamePosition();

            window.eventScroller.customFunctions.push(() => {
                this.checkProductNamePosition();
            });
        }
    }

    checkProductNamePosition () {
        const productNameBounce = this.$productName.getBoundingClientRect();
        if (productNameBounce.top < -20) {
            this.showSideLabel();
        } else {
            this.hideSideLabel();
        }
    }

    showSideLabel () {
        this.$sideLabel.classList.add('side-label--visible');
    }

    hideSideLabel () {
        this.$sideLabel.classList.remove('side-label--visible');
    }
}

export { SideLabelDetail };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-side-label="detail"]');
        $$roots.forEach($root => {
            const $rootAPI = new SideLabelDetail($root);
            $rootAPI.initialize();
        });
    }
});
